// https://fkhadra.github.io/react-toastify/introduction/
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import React, { useEffect } from 'react';
import ArtText from './ui/ArtText';
import Form from './ui/form/Form';
import { formActions, useAppDispatch, useAppSelector } from './data/store';
import { getRGBAColor } from './domain/color-provider';
import TablerCategories from './ui/TablerCategories';
import SocialShare from './ui/social-share/SocialShare';
import ConsentBanner from './ui/gdpr/ConsentBanner';
import { getRandomIcons } from './domain/icons-provider';

const App = () => {

    const dispatch = useAppDispatch();

    const iconsData = useAppSelector(store => store.root.iconsData);
    const category = useAppSelector(store => store.root.category);

    const backgroundColor = useAppSelector(store => store.form.backgroundColor);
    const backgroundColorEnabled = useAppSelector(store => store.form.backgroundColorEnabled);
    const style = backgroundColorEnabled ? {
        backgroundColor: getRGBAColor(backgroundColor)
    } : null;

    useEffect(() => {
        (async () => {
            // init icons on load
            const INITIAL_ITEMS_COUNT = 2;
            const icons = await getRandomIcons(iconsData, category, INITIAL_ITEMS_COUNT);
            dispatch(
                formActions.main({
                    icons,
                })
            );
        })();
    }, [category, dispatch, iconsData]);

    return (
        <>
            <div className="flex-1">

                <section className="container mx-auto my-8 px-4">
                    <div className="hidden lg:block">
                        <TablerCategories />
                    </div>

                    <div className="flex flex-col mb-8">

                        <div className="flex flex-col items-center order-1 xl:order-2 px-4 py-4"  style={ style ? style : {} }>
                            <div className="preview flex items-center max-w-full overflow-auto">
                                <ArtText />
                            </div>
                        </div>

                        <div className="flex-1 order-2 xlg:order-1">
                            <Form />
                        </div>
                    </div>

                    <div className="lg:hidden">
                        <TablerCategories />
                    </div>

                    <SocialShare />

                </section>

            </div>

            {/* https://fkhadra.github.io/react-toastify/introduction/ */}
            <ToastContainer
                autoClose={ 2000 }
                position="top-right"
            />

            <ConsentBanner />
        </>
    )
};

export default App;
